// extracted by mini-css-extract-plugin
module.exports = {"outlineAll":"TailwindScreenDebug_outlineAll__U4C1y"};